Ext.ux.ResizableButtonComponent = Ext.extend(Ext.Button, {
     setSize : function(w, h){
         if(w) {
             this.el.dom.style.width = w + "px";
         }
         if(h) {
             this.el.dom.style.height = h + "px";
         }
     },
    afterRender : function(){
        Ext.ux.ResizableButtonComponent.superclass.afterRender.call(this);
        this.setSize(this.width, this.height);
        Ext.get(this.el).child("button").setStyle("width", "100%");
    }
});

Ext.reg('mx_button', Ext.ux.ResizableButtonComponent);